export const SCREEN_CHANNEL = 'gamerhood';

export function pushDataLayer(event: Record<string, unknown>): void {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  } catch {
    /* dataLayer access blocked by tracking protection */
  }
}

export function trackScreenView(path: string): void {
  const screenId = path === '/' ? 'home' : path.replace(/^\//, '').replace(/\//g, '-') || 'home';
  pushDataLayer({
    event: 'screen_view',
    screenChannel: SCREEN_CHANNEL,
    screenId,
    page_path: path,
  });
}
